import Grid from "@mui/material/Grid";
import { orange } from "@mui/material/colors";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import axios from "axios";
import { useEffect, useState } from "react";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const appColor = orange[800];
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPrograms, setTotalPrograms] = useState(0);
  const [totalReports, setTotalReports] = useState(0);
  const [totalRecipes, setTotalRecipes] = useState(0);
  const [totalWorkouts, setTotalWorkouts] = useState(0);
  const [totalSchedules, setTotalSchedules] = useState(0);
  const [totalMoveNow, setTotalMoveNow] = useState(0);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
      "x-access-token": `${localStorage.getItem("token")}`
    };
    axios
      .get(`${apiBaseURL}/api/v1/admin/dashboard`, {
        headers: headers
      })
      .then((res) => {
        if (res.data.data) {
          setTotalUsers(res.data.data.findNumberOfUsers);
          setTotalPrograms(res.data.data.findNumberOfPrograms);
          setTotalReports(res.data.data.findNumberReports);
          setTotalRecipes(res.data.data.findNumberOfRecipes);
          setTotalWorkouts(res.data.data.findNumberOfWorkouts);
          setTotalSchedules(res.data.data.findNumberOfSchedules);
          setTotalMoveNow(res.data.data.findNumberOfMoveNow);
        } else {
          console.log("could not find the data!!");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="person"
                title="Total Users"
                count={totalUsers}
                route="/users"
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="fitbit"
                title="Total Programs"
                count={totalPrograms}
                route="/programs"
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="food_bank"
                title="Total Recipes"
                count={totalRecipes}
                route="/recipes"
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="fitness_center"
                title="Total Exercises"
                count={totalWorkouts}
                route="/exercises"
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="edit_calendar"
                title="Total Schedule"
                count={totalSchedules}
                route="/dayschedule"
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="people"
                title="Total Reports"
                count={totalReports}
                route="/community"
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={4}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="info"
                icon="ondemand_video"
                title="Total Move Now"
                count={totalMoveNow}
                route="/movenow"
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
